module.exports = __webpack_public_path__ + "assets/recent-posts-widget-with-thumbnails.8d73bc2d.svg";